module.exports = __webpack_public_path__ + "static/media/steflogo2.0408bbc2.webp";